const types = {
    SET_AMOUNT: '[REFERRALS] SET AMOUNT',
    SET_REFERRALS: '[REFERRALS] SET REFERRALS',
    SET_REFERRAL_INFO: '[REFERRALS] SET REFERRAL INFO',
}

export {
    types
}